import React from 'react';
import { BarChart2 } from 'lucide-react';

interface EmptyChartProps {
    height?: string;
    title?: string;
    description?: string;
    icon?: React.ReactNode;
}

export const EmptyChart: React.FC<EmptyChartProps> = ({
    height = 'h-64',
    title = 'Not Data Found',
    description,
    icon
}) => {
    return (
        <div className={`${height} flex flex-col items-center justify-center gap-3 text-muted-foreground`}>
            <div className="w-14 h-14 rounded-2xl bg-secondary/40 flex items-center justify-center">
                {icon || <BarChart2 className="w-7 h-7 opacity-40" />}
            </div>
            <div className="text-center">
                <p className="text-sm font-semibold opacity-60">{title}</p>
                {description && <p className="text-xs opacity-40 mt-0.5">{description}</p>}
            </div>
        </div>
    );
};
